import React from 'react';
import './SizeChartPage.css';

const SizeChartPage = () => {
  return (
    <div className="size-chart-page">
      <div className="size-chart-container">
        <div className="size-chart-header">
          <h1>Size Chart — TRYON</h1>
          <p>Find your perfect fit with our detailed size guide</p>
        </div>

        <div className="chart-section">
          <h2>Unisex T-Shirt Measurements (in Inches)</h2>
          <div className="table-wrapper">
            <table className="size-table">
              <thead>
                <tr>
                  <th>Size</th>
                  <th>Chest (in)</th>
                  <th>Length (in)</th>
                  <th>Shoulder (in)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="size-label">S</td>
                  <td>38</td>
                  <td>27</td>
                  <td>16.5</td>
                </tr>
                <tr>
                  <td className="size-label">M</td>
                  <td>40</td>
                  <td>28</td>
                  <td>17.5</td>
                </tr>
                <tr>
                  <td className="size-label">L</td>
                  <td>42</td>
                  <td>29</td>
                  <td>18.5</td>
                </tr>
                <tr>
                  <td className="size-label">XL</td>
                  <td>44</td>
                  <td>30</td>
                  <td>19.5</td>
                </tr>
                <tr>
                  <td className="size-label">XXL</td>
                  <td>46</td>
                  <td>31</td>
                  <td>20.5</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="measurement-guide">
          <h2>How to Measure</h2>
          <div className="measurement-grid">
            <div className="measurement-card">
              <div className="measure-icon">📏</div>
              <h3>Chest</h3>
              <p>Wrap the measuring tape under your arms around the fullest part of your chest.</p>
            </div>
            <div className="measurement-card">
              <div className="measure-icon">📐</div>
              <h3>Length</h3>
              <p>Measure from the top of the shoulder to the bottom hem.</p>
            </div>
            <div className="measurement-card">
              <div className="measure-icon">📊</div>
              <h3>Shoulder</h3>
              <p>Measure straight across the back from one shoulder seam to the other.</p>
            </div>
          </div>
        </div>

        <div className="fit-guidance">
          <h2>Fit Guidance</h2>
          <div className="fit-info">
            <div className="fit-item">
              <div className="fit-icon regular">👕</div>
              <h3>Regular Fit</h3>
              <p>Our t-shirts follow a regular fit</p>
            </div>
            <div className="fit-item">
              <div className="fit-icon between">📌</div>
              <h3>Between Sizes?</h3>
              <p>We recommend selecting the larger size for maximum comfort</p>
            </div>
          </div>
          
          <div className="fit-tips">
            <div className="tip-card oversized">
              <h3>For Oversized Look</h3>
              <p className="tip-action">→ Go one size up</p>
            </div>
            <div className="tip-card slim">
              <h3>For Snug/Slim Fit</h3>
              <p className="tip-action">→ Choose true to size</p>
            </div>
          </div>
        </div>

        <div className="note-section">
          <div className="note-icon">ℹ️</div>
          <div className="note-content">
            <h3>Important Note</h3>
            <p>
              Measurements are approximate and may vary slightly (±0.5–1 inch) depending on fabric and
              stitching.
            </p>
          </div>
        </div>

        <div className="help-section">
          <h2>Need Help Choosing Your Size?</h2>
          <p>Our customer support team is happy to help!</p>
          <div className="help-buttons">
            <a href="mailto:tyon.wear02@gmail.com" className="help-btn email">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
              </svg>
              Contact Us via Email
            </a>
            <a href="tel:+919265490049" className="help-btn phone">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
              </svg>
              Call +91 9265490049
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SizeChartPage;
